var _rect, _rect2, _circle, _circle2, _circle3, _circle4, _path, _circle5, _ellipse, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 19,
    viewBox: "0 0 34 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33.153,
    height: 19,
    rx: 2,
    fill: "#0E9347"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.32645,
    y: 2.52042,
    width: 28.6938,
    height: 14.153,
    fill: "#3BB54A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.61734,
    cy: 2.61734,
    r: 2.61734,
    fill: "#0E9347"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.6306,
    cy: 9.28282,
    r: 1.32612,
    fill: "#0E9347"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.1965,
    cy: 9.28282,
    r: 1.32612,
    fill: "#0E9347"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5359,
    cy: 2.61734,
    r: 2.61734,
    fill: "#0E9347"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1463 16.3826C33.1463 17.8282 31.9745 19 30.5289 19C29.0834 19 27.9116 17.8282 27.9116 16.3826C27.9116 14.9371 29.0834 13.7653 30.5289 13.7653C31.9745 13.7653 33.1463 14.9371 33.1463 16.3826Z",
    fill: "#0E9347"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.61734,
    cy: 16.3826,
    r: 2.61734,
    fill: "#0E9347"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.9134,
    cy: 9.94604,
    rx: 5.30449,
    ry: 5.96755,
    fill: "#0E9347"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5743 13.2005C15.1903 13.1738 14.8783 13.1231 14.6383 13.0485C14.4036 12.9685 14.2276 12.8965 14.1103 12.8325L14.3823 12.0725C14.553 12.1578 14.7583 12.2351 14.9983 12.3045C15.2436 12.3738 15.521 12.4085 15.8303 12.4085C16.1983 12.4085 16.4516 12.3551 16.5903 12.2485C16.7343 12.1365 16.8063 11.9898 16.8063 11.8085C16.8063 11.6858 16.777 11.5791 16.7183 11.4885C16.6596 11.3978 16.577 11.3178 16.4703 11.2485C16.3636 11.1791 16.2356 11.1151 16.0863 11.0565C15.9423 10.9978 15.7823 10.9365 15.6063 10.8725C15.441 10.8138 15.2756 10.7471 15.1103 10.6725C14.9503 10.5978 14.8036 10.5071 14.6703 10.4005C14.5423 10.2885 14.4383 10.1551 14.3583 10.0005C14.2783 9.8458 14.2383 9.65646 14.2383 9.43246C14.2383 9.06446 14.3476 8.75246 14.5663 8.49646C14.785 8.23513 15.121 8.06713 15.5743 7.99246V7.09646H16.4063V7.96046C16.6623 7.9818 16.8916 8.01913 17.0943 8.07246C17.297 8.12046 17.457 8.16846 17.5743 8.21646L17.3743 9.00846C17.2196 8.9498 17.0356 8.8938 16.8223 8.84046C16.6143 8.78713 16.3743 8.76046 16.1023 8.76046C15.8143 8.76046 15.5983 8.8138 15.4543 8.92046C15.3103 9.0218 15.2383 9.16313 15.2383 9.34446C15.2383 9.45113 15.2596 9.5418 15.3023 9.61646C15.345 9.6858 15.409 9.7498 15.4943 9.80846C15.5796 9.8618 15.6836 9.91513 15.8063 9.96846C15.929 10.0165 16.0676 10.0671 16.2223 10.1205C16.441 10.2058 16.6463 10.2965 16.8383 10.3925C17.0356 10.4831 17.2063 10.5925 17.3503 10.7205C17.4943 10.8431 17.6063 10.9898 17.6863 11.1605C17.7716 11.3311 17.8143 11.5338 17.8143 11.7685C17.8143 12.1205 17.705 12.4245 17.4863 12.6805C17.2676 12.9365 16.9076 13.1018 16.4063 13.1765V14.1765H15.5743V13.2005Z",
    fill: "#89C763"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCash);
export default __webpack_public_path__ + "static/media/icon-cash.812e5c3a.svg";
export { ForwardRef as ReactComponent };